let lang;

const languageModule = {
  setLang: langInput => (lang = langInput),
  getLang: () => lang
};

export default languageModule;
